import React from 'react';
import { Download, FileText } from 'lucide-react';
import { getFileUrl } from '../../lib/api';

export const PdfCatalogCard = ({ catalog }) => {
  const thumbnailSrc = getFileUrl(catalog.thumbnail_path);
  const pdfUrl = getFileUrl(catalog.pdf_path);

  return (
    <div className="group rounded-2xl bg-card border border-border shadow-[var(--shadow-elev-1)] overflow-hidden hover:border-[hsl(var(--gold)/0.45)] transition-colors duration-200">
      {/* Thumbnail */}
      <div className="relative aspect-[3/4] overflow-hidden bg-secondary">
        {thumbnailSrc ? (
          <img
            src={thumbnailSrc}
            alt={catalog.title}
            loading="lazy"
            decoding="async"
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <FileText className="w-12 h-12 text-muted-foreground" />
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
      </div>

      {/* Content */}
      <div className="p-4">
        <h3 className="font-heading font-medium text-sm mb-3 truncate">{catalog.title}</h3>
        <a
          href={pdfUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 w-full justify-center px-4 py-2.5 rounded-lg bg-[hsl(var(--gold))] text-[hsl(var(--accent-foreground))] text-sm font-medium hover:bg-[hsl(var(--gold)/0.92)] active:scale-[0.98] transition-colors duration-200"
          data-testid="catalog-download-button"
        >
          <Download className="w-4 h-4" /> İndir
        </a>
      </div>
    </div>
  );
};
